import { Flex, Text } from '@chakra-ui/react'

import deserializeRichText from '@/client/services/richText/deserializeRichText'
import isSerializedRichTextProbably from '@/client/services/richText/isSerializedRichTextProbably'

import Tippy from '@/components/UI/Tippy'

import FormContentBlock from './FormContentBlock'
import FormInputRequiredStar from './FormInputRequiredStar'
import type { FormContent, FormQuestion } from './types'

function maybeAddRequiredStarToLabel(label: FormContent): [boolean, FormContent] {
  if (isSerializedRichTextProbably(label) && label.serialization_method !== 'raw_html') {
    const descendants = deserializeRichText(label)
    // If the last node is a paragraph, add a red star to its descendants
    const lastDescendant = descendants[descendants.length - 1]

    if (descendants.length > 0 && 'type' in lastDescendant && lastDescendant.type === 'paragraph') {
      const newLastDescendant = {
        ...lastDescendant,
        children: [...lastDescendant.children, { text: '*', color: 'fg.error' }],
      }
      return [
        true,
        {
          serialization_method: 'slate_json_v1',
          content: [...descendants.slice(0, -1), newLastDescendant],
        },
      ]
    }

    return [
      true,
      {
        serialization_method: 'slate_json_v1',
        content: [...descendants, { text: '*', color: 'fg.error' }],
      },
    ]
  }
  return [false, label]
}

export default function FormQuestionMetadata({
  input,
  error,
}: {
  input: FormQuestion
  error?: string
}): React.ReactElement {
  const showRequiredStar = input.required === true && input.hideRequiredStar !== true
  const [requiredStarAdded, label] = showRequiredStar
    ? maybeAddRequiredStarToLabel(input.label)
    : [false, input.label]

  return (
    <>
      <Flex direction="row" fontWeight="bold">
        <Tippy content={error} disabled={error == null}>
          <Text as="span" fontSize={input.labelFontSize} color={error != null ? 'fg.error' : 'fg'}>
            <FormContentBlock content={label} isError={error != null} />
            {showRequiredStar && !requiredStarAdded ? <FormInputRequiredStar /> : null}
          </Text>
        </Tippy>
      </Flex>
      {input.sublabel != null ? (
        <Flex direction="row" fontWeight="normal" fontSize="small" mt="0px">
          <FormContentBlock content={input.sublabel} defaultTextColor="fg.muted" />
        </Flex>
      ) : null}
    </>
  )
}
